export const isExternalVideo = video => Boolean(video.mediaExternUrl);



// WEBPACK FOOTER //
// ./src/shared/ui-selectors/video/video-origin.js